import React from "react";
import SecondaryButton from "../buttons/SecondaryButton";
import { Divider, Switch } from "@mui/material";
import Space from "../layout/Space";
import MenuButton from "../buttons/MenuButton";
import RoundedButton from "../buttons/RoundedButton";
import RoundedButton2 from "../buttons/RoundedButton2";
import Icon1 from "../icons/Icon";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import stripeSubscriptionManager from "../api/stripe/stripeSubscriptionManager";
import { useAppContext } from "../config/AppContext";
import DropDown1 from "../dropdowns/DropDown1";
import stripeCheckoutSession from "../api/stripe/stripeCheckoutSession";
import stripeMobileSubManager from "../api/stripe/stripeMobileSubManager";
import MLTF1 from "../textfields/MLTF1";
import PrimaryButton from "../buttons/PrimaryButton";
import TextFieldChat from "../textfields/TextFieldChat";
import TextFieldEmail from "../textfields/TextFieldEmail";
import sendRequest from "../api/send/sendRequest";
import TextField2 from "../textfields/TextField2";
import { getDocDataById, updateDocDataField } from "../models/DataFunctions";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import TextField2T, { formatEuroValue } from "../textfields/TextField2T";

const Tarifs = ({ onClose, extra, workspace }) => {
  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const { currentUser, loading } = useAuth();

  const [tarif, setTarif] = useState(0);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleSetTarif = async () => {
    let article = await getDocDataById("article", extra.params?.id);
    let negoces = workspace.negoces ? workspace.negoces : [];

    let current_negoces = negoces.filter(
      (negoce) => negoce.article_id === extra.params?.id
    );
    if (current_negoces.length === 0) {
      negoces.push({
        article_id: article.id,
        price_ht: tarif,
      });
    } else {
      current_negoces[0].price_ht = tarif;
      negoces = negoces.filter(
        (negoce) => negoce.article_id !== extra.params.id
      );
      negoces.push(current_negoces[0]);
    }

    await updateDocDataFieldApi(workspace.ref, "negoces", negoces, prefix);
    handleClickVariant("Tarif enregistré", "success");
    onClose();
  };

  const handleNewValueEuros = (e) => {
    setTarif(e.target.value); // The TextField handles the comma-to-period conversion internally
  };

  const handleFetchData = async () => {
    if (currentUser) {
      try {
        const user = await getUserById(currentUser.uid);
        const org = await getOrgById(user.org_id);
        let initialTarif = 0;

        if (
          extra.negoce?.price_ht_rounded &&
          extra.negoce?.price_ht_rounded > 0
        ) {
          initialTarif = extra.negoce.price_ht_rounded;
        } else {
          initialTarif = extra.params.base_price; // Set the default value to the base price
        }

        setTarif(initialTarif);

        setUserData(user);
        setOrgData(org);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  if (loading || !currentUser || !userData) {
    return <> Loading ..</>;
  }

  return (
    <div className="bg-white flex flex-col p-4 w-c400 rounded-3xl ">
      <div className="flex flex-col gap-3 w-full">
        <div className="flex flex-row justify-between">
          {" "}
          <div className="text-h3">Tarif négocié HT</div>
          <div
            className="text-h3 text-shadow_50 cursor-pointer"
            onClick={onClose}
          >
            Fermer
          </div>
        </div>
        <div className="text-h3 text-shadow_50">
          Entrez un nombre décimal avec une virgule ex: 455,89
        </div>
        <div className="flex flex-row gap-2 items-center">
          <TextField2T
            label="Euros"
            type="euros" // Using our new type
            value={tarif}
            onChange={handleNewValueEuros}
          ></TextField2T>
        </div>

        <div className="w-full justify-end flex">
          <PrimaryButton className="w-fit" onClick={handleSetTarif}>
            Enregistrer
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default Tarifs;
